/**
 * Flow energy exchange condition creation.
 * Duplicated from Scenes for Flow independence.
 */

export interface FlowEnergyConditionInput {
	value: number;
	operator: string;
	exchange_market: string;
	minutes?: number;
}

export function createEnergyConditionFromFlow(
	input: FlowEnergyConditionInput,
): Record<string, unknown> | null {
	const { value, operator: _operator, exchange_market, minutes = 0 } = input;
	const sceneCondition = 'ppp';
	const numValue = Number(value);
	if (isNaN(numValue)) return null;

	const operator: 'eq' | 'lt' | 'gt' = (
		['less_than', 'lt'].includes(String(_operator).toLowerCase())
			? 'lt'
			: ['more_than', 'greater_than', 'gt'].includes(String(_operator).toLowerCase())
				? 'gt'
				: 'eq'
	) as 'eq' | 'lt' | 'gt';

	const rr = `${sceneCondition}:${exchange_market}:${minutes}`;

	return {
		[operator]: [{ rr }, numValue],
		_gui_purpose: 'condition',
		rrtrig: { rr: 'dt:t' },
	};
}
